import { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import opacity from "react-element-popper/animations/opacity";
import { Range } from "rc-slider";
import { AiOutlineUserAdd } from "react-icons/ai";
import DatePicker from "react-multi-date-picker";

import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

import "react-multi-date-picker/styles/layouts/prime.css";
import "rc-slider/assets/index.css";
import "./reservation.scss";

import Filter from "./Filter";
import Card from "../../common/TourItem";

export function TourListHistory() {
  return (
    <>
      <div
        class="tab-pane fade"
        id="tour-list-history"
        role="tabpanel"
        aria-labelledby="profile-tab"
      >
        <Filter></Filter>
        {[...Array(5)].map((value, index) => {
          return <Card index={index} type="reserve"></Card>;
        })}
      </div>
    </>
  );
}
export function ActiveTourList() {
  return (
    <>
      <div
        class="tab-pane fade show active"
        id="active-tour-list"
        role="tabpanel"
        aria-labelledby="home-tab"
      >
        <Filter></Filter>
        {[...Array(5)].map((value, index) => {
          return <Card index={index} type="reserve"></Card>;
        })}
      </div>
    </>
  );
}
export function ToursTab() {
  const [priceRange, setPriceRange] = useState([0, 500000]);
  const [info, setInfo] = useState({
    firstname: "",
    lastname: "",
    code: "",
    phone: "",
    birthdate: "",
    email: "",
  });
  return (
    <>
      <div
        className="modal fade"
        id="tours-tab-filter"
        aria-labelledby="filterModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title color-green" id="Label">
                فیلتر تورها
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="row m-2">
                <div className="col-3">
                  <label htmlFor="titleTour" className="form-label">
                    نام تور:
                  </label>
                </div>
                <div className="col-9">
                  <input type="text" id="titleTour" className="form-control" />
                </div>
              </div>
              <div className="row m-2">
                <div className="col-3">
                  <label htmlFor className="form-label">
                    قیمت:
                  </label>
                </div>
                <div className="col-9 position-relative ">
                  <Range
                    allowCross={false}
                    defaultValue={[0, 20]}
                    min={0}
                    max={50000000}
                    step={1000000}
                    reverse
                    onChange={(value) => {
                      setPriceRange(value);
                    }}
                  />
                  <div className="d-flex">
                    از
                    <div className="mx-1">
                      {priceRange[0]}
                      تومان
                    </div>
                    <div>تا</div>
                    <div className="mx-1">
                      {priceRange[1]}
                      تومان
                    </div>
                  </div>
                </div>
              </div>
              <div className="row m-2">
                <div className="col-3">
                  <label htmlFor="transfer" className="form-label">
                    ترنسفر:
                  </label>
                </div>
                <div className="col-9">
                  <input type="text" id="transfer" className="form-control" />
                </div>
              </div>
              <div className="row m-2">
                <div className="col-3">
                  <label>چندروزه:</label>
                </div>
                <div className="col-9">
                  <select className="form-select">
                    <option selected disabled>
                      انتخاب کنید
                    </option>
                    <option>یک روزه</option>
                    <option>دو روزه</option>
                    <option>چند روزه</option>
                  </select>
                </div>
              </div>
              <div className="row m-2">
                <div className="col-3">
                  <label htmlFor="fromDate" className="form-label ">
                    تاریخ شروع:
                  </label>
                </div>
                <div className="col-9">
                  <DatePicker
                    calendar={persian}
                    id="fromDate"
                    locale={persian_fa}
                    animations={[opacity()]}
                    style={{
                      width: "100%",
                      boxSizing: "border-box",
                      height: "26px",
                      padding: "20px 10px",
                    }}
                    containerStyle={{
                      width: "100%",
                    }}
                  />
                </div>
              </div>
              <div className="row m-2">
                <div className="col-3">
                  <label htmlFor="toDate" className="form-label  date">
                    تاریخ پایان:
                  </label>
                </div>
                <div className="col-9">
                  <DatePicker
                    calendar={persian}
                    id="toDate"
                    locale={persian_fa}
                    animations={[opacity()]}
                    style={{
                      width: "100%",
                      boxSizing: "border-box",
                      height: "26px",
                      padding: "20px 10px",
                    }}
                    containerStyle={{
                      width: "100%",
                    }}
                  />
                </div>
              </div>
              <div className="row m-2">
                <div className="col-3">
                  <label htmlFor="residence" className="form-label">
                    اقامت:
                  </label>
                </div>
                <div className="col-9">
                  <input type="text" id="residence" className="form-control" />
                </div>
              </div>
            </div>
            <div className="align-self-center m-2">
              <button type="button" className="btn btn-success px-5">
                ثبت
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="tab-pane fade" id="tours-tab">
        <div>
          <div className="d-flex m-4 flex-wrap">
            <div className="col-12 col-md-6 col-lg-6 my-2">
              <div
                className=" m-1 txt fs-15 cursor-pointer border round p-2"
                data-bs-toggle="modal"
                data-bs-target="#tours-tab-filter"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={16}
                  height={16}
                  fill="currentColor"
                  className="bi bi-funnel"
                  viewBox="0 0 16 16"
                >
                  <path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5v-2zm1 .5v1.308l4.372 4.858A.5.5 0 0 1 7 8.5v5.306l2-.666V8.5a.5.5 0 0 1 .128-.334L13.5 3.308V2h-11z" />
                </svg>
                فیلتر
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-3 col-md-4 col-sm-6">
              <div className="card border-orange m-1 mt-3 height-180">
                <div className="card-header bg-orange d-flex justify-content-between">
                  <div>
                    عنوان تور:
                    <span className="txt">سوباتان</span>
                  </div>
                  <div
                    className="cursor-pointer"
                    data-bs-toggle="modal"
                    data-bs-target="#sign-up-user"
                  >
                    <AiOutlineUserAdd
                      data-bs-toggle="tooltip"
                      title="ثبت نام"
                    ></AiOutlineUserAdd>
                  </div>
                </div>
                <div className="card-body bg-cream">
                  <div>
                    تاریخ:
                    <span className="txt">12 تا 16 بهمن</span>
                  </div>
                  <div className="mt-2">
                    ترنسفر:
                    <span className="txt">زمینی</span>
                  </div>
                  <div className="buttons d-flex justify-content-evenly mt-3">
                    <button
                      className="btn mx-2 p-1"
                      style={{
                        fontSize: "13px",
                        border: "1px solid lightblue",
                        borderRadius: "5px",
                      }}
                    >
                      لیست تور لیدر
                    </button>
                    <button
                      className="btn mx-2 p-1"
                      style={{
                        fontSize: "13px",
                        border: "1px solid lightblue",
                        borderRadius: "5px",
                      }}
                    >
                      لیست بیمه
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6">
              <div className="card border-orange m-1 mt-3 height-180">
                <div className="card-header bg-orange d-flex justify-content-between">
                  <div>
                    عنوان تور:
                    <span className="txt">سوباتان</span>
                  </div>
                  <div
                    className="cursor-pointer"
                    data-bs-toggle="modal"
                    data-bs-target="#sign-up-user"
                  >
                    <AiOutlineUserAdd
                      data-bs-toggle="tooltip"
                      title="ثبت نام"
                    ></AiOutlineUserAdd>
                  </div>
                </div>
                <div className="card-body bg-cream">
                  <div>
                    تاریخ:
                    <span className="txt">12 تا 16 بهمن</span>
                  </div>
                  <div className="mt-2">
                    ترنسفر:
                    <span className="txt">زمینی</span>
                  </div>
                  <div className="buttons d-flex justify-content-evenly mt-3">
                    <button
                      className="btn mx-2 p-1"
                      style={{
                        fontSize: "13px",
                        border: "1px solid lightblue",
                        borderRadius: "5px",
                      }}
                    >
                      لیست تور لیدر
                    </button>
                    <button
                      className="btn mx-2 p-1"
                      style={{
                        fontSize: "13px",
                        border: "1px solid lightblue",
                        borderRadius: "5px",
                      }}
                    >
                      لیست بیمه
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-4 col-sm-6">
              <div className="card border-green m-1 mt-3 height-180">
                <div className="card-header bg-green d-flex justify-content-between">
                  <div>
                    عنوان تور:
                    <span className="txt">سوباتان</span>
                  </div>
                  <div
                    className="cursor-pointer"
                    data-bs-toggle="modal"
                    data-bs-target="#sign-up-user"
                  >
                    <AiOutlineUserAdd
                      data-bs-toggle="tooltip"
                      title="ثبت نام"
                    ></AiOutlineUserAdd>
                  </div>
                </div>
                <div className="card-body bg-cream">
                  <div>
                    تاریخ:
                    <span className="txt">12 تا 16 بهمن</span>
                  </div>
                  <div className="mt-2">
                    ترنسفر:
                    <span className="txt">زمینی</span>
                  </div>
                  <div className="buttons d-flex justify-content-evenly mt-3">
                    <button
                      className="btn mx-2 p-1"
                      style={{
                        fontSize: "13px",
                        border: "1px solid lightblue",
                        borderRadius: "5px",
                      }}
                    >
                      لیست تور لیدر
                    </button>
                    <button
                      className="btn mx-2 p-1"
                      style={{
                        fontSize: "13px",
                        border: "1px solid lightblue",
                        borderRadius: "5px",
                      }}
                    >
                      لیست بیمه
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-4 col-sm-6">
              <div className="card border-blue m-1 mt-3 height-180">
                <div className="card-header bg-blue d-flex justify-content-between">
                  <div>
                    عنوان تور:
                    <span className="txt">سوباتان</span>
                  </div>
                  <div
                    className="cursor-pointer"
                    data-bs-toggle="modal"
                    data-bs-target="#sign-up-user"
                  >
                    <AiOutlineUserAdd
                      data-bs-toggle="tooltip"
                      title="ثبت نام"
                    ></AiOutlineUserAdd>
                  </div>
                </div>
                <div className="card-body bg-cream">
                  <div>
                    تاریخ:
                    <span className="txt">12 تا 16 بهمن</span>
                  </div>
                  <div className="mt-2">
                    ترنسفر:
                    <span className="txt">زمینی</span>
                  </div>
                  <div className="buttons d-flex justify-content-evenly mt-3">
                    <button
                      className="btn mx-2 p-1"
                      style={{
                        fontSize: "13px",
                        border: "1px solid lightblue",
                        borderRadius: "5px",
                      }}
                    >
                      لیست تور لیدر
                    </button>
                    <button
                      className="btn mx-2 p-1"
                      style={{
                        fontSize: "13px",
                        border: "1px solid lightblue",
                        borderRadius: "5px",
                      }}
                    >
                      لیست بیمه
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {ReactDOM.createPortal(
        <div
          className="modal fade"
          id="sign-up-user"
          tabindex="-1"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg modal-dialog-centered the-modal1">
            <div className="modal-content">
              <div className="modal-header">
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body p-5">
                <div className="row">
                  <label
                    for="firstname"
                    className="mb-3 col-12 col-sm-4 col-lg-1 col-form-label"
                  >
                    نام
                  </label>
                  <div className="mb-3 col-12 col-sm-6 col-lg-2">
                    <input
                      type="text"
                      className="form-control"
                      id="firstname"
                      value={info.firstname}
                      onChange={(e) =>
                        setInfo({ ...info, firstname: e.target.value })
                      }
                      required
                    />
                  </div>
                  <label
                    for="lastname"
                    className="mb-3 col-12 col-sm-4 col-lg-2 col-form-label"
                  >
                    نام خانوادگی
                  </label>
                  <div className="mb-3 col-12 col-sm-6 col-lg-3">
                    <input
                      type="text"
                      className="form-control"
                      id="lastname"
                      value={info.lastname}
                      onChange={(e) =>
                        setInfo({ ...info, lastname: e.target.value })
                      }
                      required
                    />
                  </div>
                  <label
                    for="code"
                    className="mb-3 col-12 col-sm-4 col-lg-1 col-form-label"
                  >
                    کدملی
                  </label>
                  <div className="mb-3 col-12 col-sm-6 col-lg-3">
                    <input
                      type="text"
                      className="form-control"
                      id="code"
                      value={info.code}
                      onChange={(e) =>
                        setInfo({ ...info, code: e.target.value })
                      }
                      required
                    />
                  </div>
                </div>
                <div className="row">
                  <label
                    for="phone"
                    className="mb-3 col-12 col-sm-4 col-lg-2 col-form-label"
                  >
                    شماره تماس
                  </label>
                  <div className="mb-3 col-12 col-sm-6 col-lg-4">
                    <input
                      type="text"
                      className="form-control"
                      id="phone"
                      value={info.phone}
                      onChange={(e) =>
                        setInfo({ ...info, phone: e.target.value })
                      }
                      required
                    />
                  </div>
                  <label
                    for="birthdate"
                    className="mb-3 col-12 col-sm-4 col-lg-2 col-form-label"
                  >
                    تاریخ تولد
                  </label>
                  <div className="mb-3 col-12 col-sm-6 col-lg-4">
                    <input
                      type="text"
                      className="form-control"
                      id="birthdate"
                      value={info.birthdate}
                      onChange={(e) =>
                        setInfo({ ...info, birthdate: e.target.value })
                      }
                      required
                    />
                  </div>
                </div>
                <div className="mb-3 row">
                  <label
                    for="email"
                    className="mb-3 col-12 col-sm-4 col-lg-2 col-form-label"
                  >
                    ایمیل
                  </label>
                  <div className="mb-3 col-12 col-sm-6 col-lg-4">
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      value={info.email}
                      onChange={(e) =>
                        setInfo({ ...info, email: e.target.value })
                      }
                      required
                    />
                  </div>
                  <button
                    type="button"
                    className="col-12 col-sm-5 col-lg-3 btn btn-primary the-btn"
                    data-bs-dismiss="modal"
                  >
                    ثبت
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>,
        document.getElementsByClassName("modals")[0]
      )}
    </>
  );
}
